import React from 'react';
import AdminLayout from '../components/AdminLayout';
import BrandRouterCard from '../components/BrandRouterCard';

function AdminBrandRouterPage() {
  return (
    <AdminLayout
      title="Brand Router"
      subtitle="Configure dynamic brand routing, intent patterns, and link templates."
    >
      <BrandRouterCard />
    </AdminLayout>
  );
}

export default AdminBrandRouterPage;